import { useMemo } from 'react';
import { useWorkplacesQuery } from '../../../graphql/graphql';

const useWorkplaces = () => {
	const userWorkplaces = useWorkplacesQuery();

	const workplaceIds = useMemo(() => {
		const tempIds: string[] = [];
		userWorkplaces?.data?.workplaces?.data?.forEach(item => {
			if (item?.id) {
				tempIds.push(item.id);
			}
		});
		return tempIds;
	}, [userWorkplaces]);

	return { workplaceIds };
};

export default useWorkplaces;
